<template>
  <v-container
    class="physical-activity-progress-daily-activity-goal"
    v-disable-all="hasReadOnlyAccess"
  >
    <v-row>
      <!-- Note: Release 2.0 scope reduction  -->
      <!-- <v-col cols="6" style="border-right: 1px solid #ccc">
        <v-row class="ma-2">
          <v-col cols="12">
            <h3>{{ $ucfirst($t("pa.dailyActivityOfLastWeek")) }}</h3>
            <apexchart
              :options="chartOptions"
              :series="chartSeries"
              type="bar"
              height="300"
            />
          </v-col>
        </v-row>
        <v-row class="ma-2 mb-8" v-if="logLastWeek">
          <v-col v-if="logLastWeek == 1 || logLastWeek == 4">
            <v-col>
              <steps-sport-no-sport type="" :average="true" />
              <span class="ml-2">{{ Math.round(averageStepsLastWeek) }}</span>
            </v-col>
          </v-col>
          <v-col v-if="logLastWeek == 2 || logLastWeek == 3">
            <v-row>
              <v-col>
                <smart-icon icon="mdi-fire" />
                <span>{{ numberOfDaysGoalReachedLastWeek }}/7</span>
              </v-col>
              <v-col>
                <steps-sport-no-sport type="no sport" :average="true" />
                <span class="ml-2">{{
                  Math.round(averageStepsNoSportLastWeek)
                }}</span>
              </v-col>
              <v-col>
                <steps-sport-no-sport type="sport" :average="true" />
                <span class="ml-2">{{
                  Math.round(averageStepsSportLastWeek)
                }}</span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row class="ma-2" v-if="tips">
          <v-col cols="12" class="border bg-color-coro-info-100">

            <div class="d-flex align-center mb-2">
              <smart-icon icon="mdi-lightbulb-on-outline" />
              <h4 class="mb-0 mt-1 ml-2">
                {{ $ucfirst($t("pa.tipsToIncreaseYourDailyActivity")) }}
              </h4>
            </div>
            <span v-for="tip in tips" v-bind:key="tip.node.id">
              <p class="ml-3 mb-1">{{ tip.node.message }}</p>
            </span>
          </v-col>
        </v-row>
      </v-col> -->
      <v-col cols="12" md="10" lg="10" xl="8">
        <v-row class="ma-2">
          <v-col cols="12">
            <v-row>
              <v-col>
                <h3>{{ $ucfirst($t("pa.dailyActivityGoalSteps")) }}</h3>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3">{{ $ucfirst($t('pa.level')) }}</v-col>
              <v-col>
                {{ currentStepGoalClassReadable() }}
                <v-dialog v-model="dialog" persistent max-width="600px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      small
                      outlined
                      v-bind="attrs"
                      v-on="on"
                      class="ml-3"
                    >
                      <smart-icon icon="mdi-pencil-outline" />
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title class="mb-2 d-flex justify-space-between">
                      <span>{{ $ucfirst($t("pa.changeStepGoalClass")) }}</span>
                      <v-btn
                        class="pull-right btn-transparent"
                        icon
                        plain
                        @click="onCancelStepGoalClass"
                      >
                        <v-icon>
                          mdi-close
                        </v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-row>
                        <v-col cols="12">
                          <v-select
                            v-model="newStepGoalClass"
                            :items="stepGoalClassesToSelect"
                            dense
                            ref="dialogInput"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn outlined text @click="onCancelStepGoalClass">
                        <smart-icon icon="mdi-cancel" size="16" />
                        {{ $ucfirst($t('buttons.cancel', {catalog: 'app_mobile'})) }}
                      </v-btn>
                      <v-btn outlined text @click="onSaveStepGoalClass">
                        <smart-icon icon="mdi-content-save-outline" size="16" />
                        {{ $ucfirst($t('buttons.save', {catalog: 'app_mobile'})) }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3">
                {{ $ucfirst($t("pa.proposed")) }}
                <target-sport-no-sport-icon type="no sport" />
              </v-col>
              <v-col>{{ proposedStepsNoSport }}</v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3"
                ><target-sport-no-sport-icon type="no sport"
              /></v-col>
              <v-col>
                <v-form ref="form" v-model="isValidStepCount" class="d-flex align-center">
                  <v-btn
                    fab
                    small
                    outlined
                    @click="pressMinus"
                    :disabled="minusDisabled"
                    class="mr-3"
                  >
                    <smart-icon icon="mdi-minus" />
                  </v-btn>
                  <v-text-field
                    v-model="stepsNoSport"
                    :rules="numberRules"
                    :disabled="updating"
                    @keypress="onKeypress"
                    @paste="onPaste"
                    class="v-patient-overview-pa-goal-setting-weekly-sports-goal__step-goal-input"
                    :maxlength="7"
                  />
                  <v-btn
                    fab
                    small
                    outlined
                    @click="pressPlus"
                    :disabled="plusDisabled"
                    class="ml-3"
                  >
                    <smart-icon icon="mdi-plus" />
                  </v-btn>
                  <v-btn
                    v-if="unsavedChanges()"
                    class="ml-3"
                    color="primary"
                    elevation="2"
                    @click="saveStepGoal"
                    :disabled="!isValidStepCount"
                  >
                    <v-icon left>mdi-content-save-outline</v-icon>
                    {{ $ucfirst($t('buttons.save', {catalog: 'app_mobile'})) }}
                  </v-btn>
                </v-form>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" sm="3"
                ><target-sport-no-sport-icon type="sport"
              /></v-col>
              <v-col>{{ $ucfirst($t("pa.ifYouReportSports")) }}</v-col>
            </v-row>
            <!-- Note: Release 2.0 scope reduction  -->
            <!-- <v-row>
              <v-col cols="12">
                <h4>{{ $ucfirst($t("pa.yourDailyActivityGoalsNextWeek")) }}</h4>
                <v-row
                  class="
                    mx-5
                    my-2
                    v-patient-overview-pa-goal-setting-weekly-sports-goal__activity-days
                  "
                >
                  <v-col
                    v-for="(activityDay, i) in activityDays"
                    v-bind:key="activityDay.id"
                    class="
                      v-patient-overview-pa-goal-setting-weekly-sports-goal__activity-days__day
                    "
                  >
                    <v-row
                      class="
                        v-patient-overview-pa-goal-setting-weekly-sports-goal__activity-days__day-name
                        flex-grow-1
                      "
                    >
                      <strong>{{ daysToSelect[i] }}</strong>
                    </v-row>
                    <v-row class="">
                      <v-col class="" style="min-height: 350px">
                        <v-row
                          v-if="activityDay.activities.length"
                          class="
                            v-patient-overview-pa-goal-setting-weekly-sports-goal__activity-days__activities
                          "
                        >
                          <v-col
                            cols="12"
                            v-for="activity in activityDay.activities"
                            v-bind:key="activity.id"
                            class="
                              v-patient-overview-pa-goal-setting-weekly-sports-goal__activity-days__activity
                            "
                          >
                            <div
                              v-if="
                                activity.patientActivityType.activityType
                                  .name !== '6MWT'
                              "
                            >
                              <div style="text-align: center">
                                <activity-icon
                                  :activityType="
                                    activity.patientActivityType.key
                                  "
                                />
                              </div>
                              <div style="text-align: center">
                                {{ activity.duration }} min
                              </div>
                              <div style="text-align: center">
                                {{
                                  activity.patientActivityType.activityType.name
                                }}
                              </div>
                            </div>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="activityDay.activities"
                      class="flex-grow-1"
                      style="height: 50px"
                    >
                      <v-col style="border-top: 1px solid #ccc" justify="end">
                        <target-sport-no-sport-icon
                          :type="
                            activityDay.activities.length ? 'sport' : 'no sport'
                          "
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row> -->
          </v-col>
        </v-row>
      </v-col>
    </v-row>
     <v-dialog
      v-model="showMessageStepsNoSport"
      width="600px"
    >
      <div class="dashboard-dialog-window">
        <div class="dashboard-dialog-window__message">
          {{ $ucfirst($t("startMoving.alerts.bigStep", { catalog: 'app_mobile' })) }}
        </div>
        <div class="dashboard-dialog-window__actions">
          <v-btn
            x-large
            text
            class="ml-4"
            @click="showMessageStepsNoSport = false"
            color="primary"
          >
            {{ $ucfirst($t('ok')) }}
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <unsaved-changes-warning
      ref="unsavedChangesWarning"
      :targetScreensToSkip="['PatientOverview']"
    ></unsaved-changes-warning>
  </v-container>
</template>

<script>
import TargetSportNoSportIcon from "../../../components/Parts/TargetSportNoSportIcon.vue";
import SmartIcon from "../../../components/Parts/SmartIcon.vue";
import moment from "moment";
import gql from "graphql-tag";
import { mapGetters } from "vuex";
import UnsavedChangesWarning from "../../../components/Parts/UnsavedChangesWarning.vue";
import { debounce } from "debounce";
import store from "dashboard/store";
import {dailySportsActivityWeekStartDate} from "dashboard/store/patient-summary/getters";
// import ActivityIcon from "../../../components/Parts/ActivityIcon.vue";
// import StepsSportNoSport from "../../../components/Parts/StepsSportNoSport.vue";

/**
 * Component PatientOverviewPAGoalSettingDailyActivityGoal.vue
 *
 * @module PatientOverviewPAGoalSettingDailyActivityGoal
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.7] app/src/APP_DASHBOARD/templates/views/Patient/PA/PatientOverviewPAGoalSettingDailyActivityGoal.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "PatientOverviewPAGoalSettingDailyActivityGoal",
  components: {
    TargetSportNoSportIcon,
    SmartIcon,
    UnsavedChangesWarning,
    // StepsSportNoSport,
    // ActivityIcon,
  },
  data: function () {
    return {
      proposedStepsNoSport: null,
      stepsNoSport: null,
      activityDays: null,
      showMessageStepsNoSport: null,
      currentStepGoalClass: null,
      newStepGoalClass: null,
      dialog: false,
      stepGoalClassesToSelect: [
        { value: 'INACTIVE', text: this.getTextForStepGoalClass('INACTIVE') },
        { value: 'BEGINNER', text: this.getTextForStepGoalClass('BEGINNER') },
        { value: 'INTERMEDIATE', text: this.getTextForStepGoalClass('INTERMEDIATE') },
        { value: 'ADVANCED', text: this.getTextForStepGoalClass('ADVANCED') },
      ],
      daysToSelect: [
        this.$ucfirst(this.$t("date.monday")),
        this.$ucfirst(this.$t("date.tuesday")),
        this.$ucfirst(this.$t("date.wednesday")),
        this.$ucfirst(this.$t("date.thursday")),
        this.$ucfirst(this.$t("date.friday")),
        this.$ucfirst(this.$t("date.saturday")),
        this.$ucfirst(this.$t("date.sunday")),
      ],
      tips: null,
      logLastWeek: null,
      averageStepsLastWeek: null,
      averageStepsNoSportLastWeek: null,
      averageStepsSportLastWeek: null,
      stepGoalNoSportLastWeek: null,
      numberOfDaysGoalReachedLastWeek: null,
      chartOptions: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        colors: [this.$color.coro["info-500"]],
        zoom: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        dataLabels: {
          enabled: false,
        },
        grid: {
          row: {
            colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
            opacity: 0.5,
          },
        },
        yaxis: {
          title: {
            text: this.$ucfirst(this.$t('stepCounterTool.stepsCounter', { catalog: 'app_mobile' })),
            style: {
              fontSize: '0.75rem'
            },
          },
          min: 0,
          tickAmount: 5,
          labels: {
            style: {
              fontSize: '0.75rem'
            }
          }
        },
        xaxis: {
          title: {
            text: this.$ucfirst(this.$t("alerts.time")),
            style: {
              fontSize: '0.75rem'
            },
          },
          categories: [],
          labels: {
            style: {
              fontSize: '0.75rem'
            }
          }
        },
        tooltip: {
          style: {
            fontSize: '0.85rem'
          }
        },
        noData: {
          text: this.$t("noData"),
          align: "center",
          verticalAlign: "middle",
          offsetX: 0,
          offsetY: -32,
          style: {
            // color: this.$color.coro["primary-500"],
            fontSize: "22px",
            fontFamily: "Futura",
          },
        },
      },
      chartSeries: [],
      numberRules: [
        (v) => {
          if ((v || "").toString().includes("e")) {
            return this.$ucfirst(this.$t("validation.onlyNumbersAreAllowed"));
          }
          if (v < 0) {
            return this.$ucfirst(this.$t("validation.onlyPositiveNumbers"));
          }
          if (!/^\d+$/.test(v) || !+v) {
            return this.$ucfirst(this.$t("dummy.general.invalid_whole_number", {catalog: 'validators'}));
          }
          return true
        },
      ],
      initiallyLoaded: false,
      updating: false,
      isValidStepCount: true
    };
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      hasReadOnlyAccess: "user/hasReadOnlyAccess",
      unsavedChanges: 'patientSummary/unsavedChanges'
    }),
    activeLevelOfGuidance() {
      const behaviourComponent = this.$store.state.patientSummary.behaviourComponents
        .find(item => item.key === 'STARTMOVING');
      return behaviourComponent?.levelOfGuidance;
    },
    minusDisabled() {
      const parsed = parseInt(this.stepsNoSport);
      return this.updating || parsed <= 0 || parsed - 100 <= 0
    },
    plusDisabled() {
      const parsed = parseInt(this.stepsNoSport);
      return this.updating
    }
  },
  watch: {
    patientId: function () {
      this.loadActivityWeek();
      // Note: Release 2.0 scope reduction
      // this.getTips();
    },

    stepsNoSport: debounce(function (curr, prev) {
      if (+curr !== +prev && prev !== null) {
        this.$store.dispatch('patientSummary/toggleUnsavedChanges', true)
      }
    }, 200),

    currentStepGoalClass(value) {
      this.newStepGoalClass = value
      this.showNotification()
    },

    dialog(curr) {
      if (curr) {
        setTimeout(() => {
          this.$refs.dialogInput.focus();
        }, 200)
      }
    }
  },
  mounted: function () {
    this.loadActivityWeek();
    // Note: Release 2.0 scope reduction
    // this.getTips();
  },
  methods: {
    onSaveStepGoalClass() {
      // Update stepGoalClass, refetch and  close dialog.

      const startDate = store.getters['patientSummary/dailySportsActivityWeekStartDate'];

      this.$app.apolloMobileClient
          .mutate({
            mutation: gql`
          mutation createUpdateMyActivityWeek(
            $patientId: Int
            $startDate: DateTime!
            $assignedStepLevel: String
          ) {
            createUpdateMyActivityWeek(
              activityWeek: {
                patientId: $patientId
                startDate: $startDate
                assignedStepLevel: $assignedStepLevel
              }
            ) {
              id
            }
          }
        `,
            variables: {
              patientId: parseInt(this.patientId),
              startDate: startDate,
              assignedStepLevel: this.newStepGoalClass,
            },
          })
          .then((result) => {
            // Refetch.
            this.loadActivityWeek(false);

            // Close dialog.
            this.dialog = false;
          })
          .catch((err) => {
            this.$toasted.show("Cannot do mutation. Try again later.");
          });

    },
    onCancelStepGoalClass() {
      this.dialog = false;
      this.newStepGoalClass = this.currentStepGoalClass;
    },
    currentStepGoalClassReadable() {
      return this.getTextForStepGoalClass(this.currentStepGoalClass);
    },
    pressPlus() {
      const newValue = parseInt(this.stepsNoSport) + 100;
      this.stepsNoSport = isNaN(newValue) ? '' : newValue;
    },
    pressMinus() {
      const newValue = parseInt(this.stepsNoSport) - 100;
      this.stepsNoSport = isNaN(newValue) ? '' : newValue >= 0 ? newValue : 0
    },
    toggleStepGoalWarning() {
      if (this.stepsNoSport > this.proposedStepsNoSport + 500) {
        this.showMessageStepsNoSport = true
      } else {
        this.showMessageStepsNoSport = false;
      }
    },
    saveStepGoal() {
      if (!this.isValidStepCount) {
        return;
      }
      this.toggleStepGoalWarning();
      this.updateStepGoal();
    },
    updateStepGoal() {
      this.updating = true

      const startDate = store.getters['patientSummary/dailySportsActivityWeekStartDate'];

      this.$app.apolloMobileClient
          .mutate({
            mutation: gql`
          mutation createUpdateMyActivityWeek(
            $patientId: Int
            $startDate: DateTime!
            $dailyStepGoalNoSport: Int
          ) {
            createUpdateMyActivityWeek(
              activityWeek: {
                patientId: $patientId
                startDate: $startDate
                dailyStepGoalNoSport: $dailyStepGoalNoSport
              }
            ) {
              id
              dailyStepGoalNoSport
              suggestedDailyStepGoalNoSport
            }
          }
        `,
            variables: {
              patientId: parseInt(this.patientId),
              startDate : startDate,
              dailyStepGoalNoSport: parseInt(this.stepsNoSport),
            },
          })
          .then(() => {
            // Updated!
            this.loadActivityWeek();
            this.showNotification();
            this.$store.dispatch('patientSummary/toggleUnsavedChanges', false);
          })
          .catch((err) => {
            this.$toasted.show("Cannot do mutation. Try again later.");
          });
    },
    async loadActivityWeek() {
      const dailySportsActivityWeekStartDate = store.getters['patientSummary/dailySportsActivityWeekStartDate'];

      const activityWeek = await this.getActivityWeek(dailySportsActivityWeekStartDate);

      this.proposedStepsNoSport = activityWeek.suggestedDailyStepGoalNoSport;

      if (activityWeek.activityDays) {
        this.currentStepGoalClass = activityWeek.assignedStepLevel;
      }

      if (activityWeek.dailyStepGoalNoSport >= 0) {
        this.stepsNoSport = activityWeek.stepsSetInDashboard ? activityWeek.dailyStepGoalNoSport : activityWeek.suggestedDailyStepGoalNoSport;
      }

      this.initiallyLoaded = true;
      this.updating = false;
    },
    getActivityWeek(startDate) {
        return this.$app.apolloMobileClient
            .mutate({
              mutation: gql`
          mutation createUpdateMyActivityWeek(
            $patientId: Int
            $startDate: DateTime!
          ) {
            createUpdateMyActivityWeek(
              activityWeek: {
                patientId: $patientId
                startDate: $startDate
              }
            ) {
                id
                startDate
                suggestedDailyStepGoalNoSport
                dailyStepGoalNoSport
                assignedStepLevel
                completedActivityCount
                stepsSetInDashboard
                activityDays {
                  id
                  date
                  activities {
                    id
                    date
                    time
                    duration
                    intensity
                    caloriesPlanned
                    caloriesBurned
                    patientActivityType {
                      id
                      key
                      activityType {
                        name
                      }
                    }
                  }
                  assignedStepLevel
                }
            }
          }
        `,
              variables: {
                patientId: parseInt(this.patientId),
                startDate : startDate
              },
            })
            .then((result) => {
              return result?.data?.createUpdateMyActivityWeek;
            });
      },
    getDailyActivityTip() {
      this.$app.apolloMobileClient
          .query({
            query: gql`
              query dailyActivityTip(
                $patientId: Int!
              ){
                dailyActivityTip(patientId: $patientId) {
                  id
                  behaviourComponentLevel {
                    levelOfGuidance
                  }
                  type
                  handlerType
                  title
                  message
                  actionMessage
                  warningMessage

                }
              }
            `,
            variables: {
              patientId: this.patientId
            }
          })
          .then((result) => {
            if(result.data.dailyActivityTip.message)
            this.tips = [{
              node: {
                message: result.data.dailyActivityTip.message
              }
            }];
          })
    },
    async getTips() {
      // LOG 2 -> 1 tip.
      // LOG 1/3/4 -> 3 tips.

      const startMovingLevels =
        await this.$app.behaviourComponentManager.getPeriodsForBehaviourComponents(
          this.patientId,
          "STARTMOVING",
          [2],
          true
        );

      // Has not been in LOG 2:
      if (!startMovingLevels.STARTMOVING.length) {
        this.getDailyActivityTip();
      } else {
        // LOG 1, 3, 4.
        this.$app.apolloMobileClient
          .query({
            query: gql`
              {
                myTips(
                  conditions: {
                    gate: and
                    inputs: [
                      { field: state, value: "active" }
                      { field: type, value: "TIP_DAILY_ACTIVITY__CASE_TIP_DAILY_ACTIVITY" }
                    ]
                  }
                  orders: [{ field: activateDate, direction: desc }]
                  limit: 3
                ) {
                  edges {
                    node {
                      id

                      message

                      parameters {
                        key
                        value
                      }
                    }
                  }
                }
              }
            `,
          })
          .then((result) => {
            this.tips = result.data.myTips.edges;

            if (!result.data.myTips.edges.length) {
              // Get dailyActivityTip
              this.getDailyActivityTip();
            }
          });
      }
    },
    showNotification() {
      // show notification if patient is not currently in LOG 2
      if (!this.initiallyLoaded || this.activeLevelOfGuidance === 2) {
        return;
      }
      this.$toasted.clear();
      this.$toasted.show(
        this.$ucfirst(
          this.$t("pa.goalSettingNoChangesIfLOGNotTwo", {
            params: {
              levelOfGuidance: '2',
            },
          })
        ), { icon: 'error', duration: 10000 }
      )
    },
    onKeypress(event) {
      const onlyNumbers = /\d/
      if (!onlyNumbers.test(event.key)) {
        event.preventDefault();
      }
    },
    onPaste(event) {
      const pasted = event.clipboardData.getData('text/plain')
      const parsed = parseInt(pasted)
      event.preventDefault()

      if (!isNaN(parsed) && !(parsed < 0)) {
        this.stepsNoSport = parsed
      } else {
        this.stepsNoSport = ''
      }
    },
    getTextForStepGoalClass(level) {
      if (!level) return '';
      return this.$app.activityManager.getTextForStepGoalClass(level);
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.unsavedChanges()) {
      this.$refs.unsavedChangesWarning.prepareToExit(to.name)
      return false;
    }
    next();
  }
};
</script>

<style lang="scss">
@import "../../../../../scss/colors";

.v-patient-overview-pa-goal-setting-weekly-sports-goal__activity-days__day {
  &:nth-of-type(6) {
    background-color: map-get($coroColors, lightgray);
  }
  &:nth-of-type(7) {
    background-color: map-get($coroColors, lightgray);
  }
}

.v-patient-overview-pa-goal-setting-weekly-sports-goal__step-goal-input {
  max-width: 160px;
  & input {
    text-align: center;
  }
}
</style>
